define('presentation/settings/voicemailBoxes/facades/addVoicemailBoxGreetingsFacade',['businessServices/authentication/sessionAccountInfo',
    'businessServices/converters/durationTimeFormatter',
    'businessServices/uploads/customerUpload',
    'common/promises/promiseFactory',
    'constants/audioFileConversionStatusConstants',
    'externalDependencies/clientWebSocket',
    'presentation/common/dateTimeValue',
    'presentation/common/voicemail/presentationObjects/voicemailGreetingAudioObject',
    'presentation/settings/voicemailBoxes/presentationObjects/voicemailBoxGreetingPresentationObject',
], function() {
    const PromiseFactoryConstructor = require('common/promises/promiseFactory');
    let _promiseFactory = null;

    const DateTimeValueConstructor = require('presentation/common/dateTimeValue');
    const TimeFormatterConstructor = require('businessServices/converters/durationTimeFormatter');
    const VoicemailGreetingAudioObjectConstructor = require('presentation/common/voicemail/presentationObjects/voicemailGreetingAudioObject');
    const VoicemailGreetingPresentationObjectConstructor = require('presentation/settings/voicemailBoxes/presentationObjects/voicemailBoxGreetingPresentationObject');

    const _audioFileConversionStatusConstants = require('constants/audioFileConversionStatusConstants');
    const _customerUpload = require('businessServices/uploads/customerUpload');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const _greetingSocket = clientWebSocket.forApplication("voicemailBoxVoicemailGreetings");

    const _buildVoicemailBoxGreetingForDisplay = (voicemailBoxGreeting) => {
        let voicemailGreetingPresentationObject = new VoicemailGreetingPresentationObjectConstructor();
        voicemailGreetingPresentationObject.voicemailBoxGreetingId = voicemailBoxGreeting.voicemailBoxGreetingId;
        voicemailGreetingPresentationObject.name(voicemailBoxGreeting.name);
        voicemailGreetingPresentationObject.isBuiltIn(voicemailBoxGreeting.isSystemGreeting);
        if (voicemailBoxGreeting.createdDateTime) {
            voicemailGreetingPresentationObject.createdDateTime = new DateTimeValueConstructor(voicemailBoxGreeting.createdDateTime);
        }
        if (voicemailBoxGreeting.updatedDateTime) {
            voicemailGreetingPresentationObject.modifiedDateTime = new DateTimeValueConstructor(voicemailBoxGreeting.updatedDateTime);
        }

        let audioObject = new VoicemailGreetingAudioObjectConstructor();
        if (voicemailBoxGreeting.conversionStatus === _audioFileConversionStatusConstants.converted) {
            audioObject.audioData(voicemailBoxGreeting.mp3Url);
            audioObject.duration(_getFormattedDurationProperty(voicemailBoxGreeting.durationInMilliseconds/1000));
        } else {
            audioObject.showConversionMessage(true);
        }
        voicemailGreetingPresentationObject.greetingAudioObject(audioObject);

        return voicemailGreetingPresentationObject;
    };

    const _getFormattedDurationProperty = (greetingDurationInSeconds) => {
        let formatter = new TimeFormatterConstructor();
        let formattedTimeDuration = formatter.formatTotalSeconds(greetingDurationInSeconds);
        return formattedTimeDuration;
    };

    const _getCurrentGreetingId = (voicemailBoxId) => {
        return _promiseFactory.defer((promise) => {
            if (voicemailBoxId === null) {
                promise.resolve(null);
                return;
            }
            
            const request = {
                voicemailBoxId: voicemailBoxId
            };

            _greetingSocket.send("getCurrentGreeting", request, (response) => {
                if (response.isFound === false) {
                    promise.reject(new Error("voicemailBox not found"));
                    return;
                }

                if (response.customGreetingId) {
                    promise.resolve(response.customGreetingId);
                    return;
                } else if (response.systemGreetingId) {
                    promise.resolve(response.systemGreetingId);
                    return;
                }

                promise.resolve(null);
            });
        });
    };

    const _listSystemVoicemailBoxGreetings = () => {
        return _promiseFactory.defer((promise) => {
            _greetingSocket.send("listSystemGreetings", {}, (systemGreetings) => {
                let systemGreetingsList = systemGreetings.map(systemGreeting => {
                    let voicemailGreetingPresentationObject = new VoicemailGreetingPresentationObjectConstructor();
                    voicemailGreetingPresentationObject.voicemailBoxGreetingId = systemGreeting.systemVoicemailBoxGreetingId;
                    voicemailGreetingPresentationObject.name(systemGreeting.name);
                    voicemailGreetingPresentationObject.isBuiltIn(true);
                    if (systemGreeting.createdDateTime) {
                        voicemailGreetingPresentationObject.createdDateTime = new DateTimeValueConstructor(systemGreeting.createdDateTime);
                    }
                    if (systemGreeting.updatedDateTime) {
                        voicemailGreetingPresentationObject.modifiedDateTime = new DateTimeValueConstructor(systemGreeting.updatedDateTime);
                    }

                    let audioObject = new VoicemailGreetingAudioObjectConstructor();
                    audioObject.audioData(systemGreeting.mp3Url);
                    audioObject.duration(_getFormattedDurationProperty(systemGreeting.durationInMilliseconds/1000));
                    voicemailGreetingPresentationObject.greetingAudioObject(audioObject);

                    return voicemailGreetingPresentationObject;
                });

                promise.resolve(systemGreetingsList);
            });

        });
    };

    const _listVoicemailBoxGreetings = (voicemailBoxId) => {
        return _promiseFactory.defer((promise) => {
            const request = {
                voicemailBoxId: voicemailBoxId
            };

            _greetingSocket.send("listVoicemailBoxGreetings", request, (voicemailGreetings) => {
                let voicemailGreetingsList = voicemailGreetings.map(greeting => {
                    return _buildVoicemailBoxGreetingForDisplay(greeting);
                });
                promise.resolve(voicemailGreetingsList);
            });
        });
    };

    const _getVoicemailBoxGreetings = (voicemailBoxId) => {
        return _promiseFactory.defer((promise) => {
            let allVoicemailGreetings = [];
            const greetingsPromiseFactory = new PromiseFactoryConstructor();
            if (voicemailBoxId === null) {
                greetingsPromiseFactory.deferIndefinitely((systemGreetingsPromise) => {
                    _listSystemVoicemailBoxGreetings()
                        .fail(systemGreetingsPromise.reject)
                        .done((defaultGreeting) => {
                            allVoicemailGreetings = defaultGreeting;
                            systemGreetingsPromise.resolve();
                        });
                });
            } else {
                greetingsPromiseFactory.deferIndefinitely((greetingsPromise) => {
                    _listVoicemailBoxGreetings(voicemailBoxId)
                        .fail(greetingsPromise.reject)
                        .done((voicemailBoxGreetings) => {
                            allVoicemailGreetings = voicemailBoxGreetings;
                            greetingsPromise.resolve();
                        });
                });
            }

            greetingsPromiseFactory.wait()
                .fail(promise.reject)
                .done(() => {
                    promise.resolve(allVoicemailGreetings);
                });
        });
    };

    const _addGreeting = (voicemailBoxId, voicemailBoxGreeting) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            const fileHandle = voicemailBoxGreeting.file();
            _customerUpload.uploadFile(fileHandle)
                .fail(promise.reject)
                .done(({uploadId}) => {
                    const createGreetingRequest = {
                        voicemailBoxId : voicemailBoxId,
                        name: voicemailBoxGreeting.name(),
                        uploadId: uploadId,
                    };
                    _greetingSocket.send("createVoicemailBoxGreeting", createGreetingRequest, (response) => {
                        if (response.isSuccessful) {
                            promise.resolve(response.voicemailBoxGreetingId);
                        } else {
                            promise.reject(new Error("error creating greeting"));
                        }
                    });
                });
        });
    };

    const _updateGreetingPrompt = (voicemailBoxId, voicemailBoxGreeting) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            const fileHandle = voicemailBoxGreeting.file();
            _customerUpload.uploadFile(fileHandle)
                .fail(promise.reject)
                .done(({uploadId}) => {
                    const updateRequest = {
                        voicemailBoxId : voicemailBoxId,
                        voicemailBoxGreetingId : voicemailBoxGreeting.voicemailBoxGreetingId,
                        name : voicemailBoxGreeting.name(),
                        uploadId: uploadId,
                    };

                    _greetingSocket.send("updateVoicemailBoxGreeting", updateRequest, (response) => {
                        if (response.isSuccessful) {
                            promise.resolve();
                        } else {
                            promise.reject(new Error("error updating greeting"));
                        }
                    });
                });
        });
    };

    const _updateGreetingName = (voicemailBoxId, voicemailBoxGreeting) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            const request = {
                voicemailBoxId : voicemailBoxId,
                voicemailBoxGreetingId: voicemailBoxGreeting.voicemailBoxGreetingId,
                name: voicemailBoxGreeting.name(),
            };
            _greetingSocket.send("updateVoicemailBoxGreetingName", request, (response) => {
                if (response.isSuccessful) {
                    promise.resolve();
                } else {
                    promise.reject(new Error("error updating greeting"));
                }
            });
        });
    };

    const _processVoicemailBoxGreetingForSave = (voicemailBoxId, voicemailBoxGreeting) => {
        let promiseFactory = new PromiseFactoryConstructor();
        return promiseFactory.deferIndefinitely((promise) => {
            if (voicemailBoxGreeting.requiresUpdate === false || voicemailBoxGreeting.isBuiltIn() || voicemailBoxGreeting.isAccount) {
                promise.resolve();
            } else if (voicemailBoxGreeting.isDeleted() === true) {
                _deleteVoicemailBoxGreeting(voicemailBoxId, voicemailBoxGreeting)
                    .fail(promise.reject)
                    .done(promise.resolve);
            } else {
                if (voicemailBoxGreeting.voicemailBoxGreetingId === null) {
                    _addGreeting(voicemailBoxId, voicemailBoxGreeting)
                        .fail(promise.reject)
                        .done(promise.resolve);
                } else {
                    if (voicemailBoxGreeting.file()) {
                        _updateGreetingPrompt(voicemailBoxId, voicemailBoxGreeting)
                            .fail(promise.reject)
                            .done(promise.resolve);
                    } else {
                        _updateGreetingName(voicemailBoxId, voicemailBoxGreeting)
                            .fail(promise.reject)
                            .done(promise.resolve);
                    }
                }
            }
        });
    };

    const _saveVoicemailBoxGreetings = (voicemailBoxId, voicemailBoxGreetings) => {
        return _promiseFactory.deferIndefinitely((promise) => {
            let saveVoicemailGreetingsPromise = new PromiseFactoryConstructor();
            voicemailBoxGreetings.forEach(voicemailBoxGreeting => {
                saveVoicemailGreetingsPromise.deferIndefinitely((saveDeferredObject) => {
                    _processVoicemailBoxGreetingForSave(voicemailBoxId, voicemailBoxGreeting)
                        .fail(saveDeferredObject.reject)
                        .done((greetingId) => {
                            if (voicemailBoxGreeting.voicemailBoxGreetingId === null && greetingId !== undefined) {
                                voicemailBoxGreeting.voicemailBoxGreetingId = greetingId;
                            }
                            saveDeferredObject.resolve();
                        });
                });
            });

            saveVoicemailGreetingsPromise.wait()
                .fail(promise.reject)
                .done(() => {
                    promise.resolve({
                        status : "success",
                        voicemailGreetings : voicemailBoxGreetings
                    });
                });
        });
    };

    const _deleteVoicemailBoxGreeting = (voicemailBoxId, voicemailBoxGreeting) => {
        return _promiseFactory.defer((promise) => {
            const request = {
                voicemailBoxId : voicemailBoxId,
                voicemailBoxGreetingId : voicemailBoxGreeting.voicemailBoxGreetingId
            };
            _greetingSocket.send("deleteVoicemailBoxGreeting", request, (result) => {
                if (result.isSuccessful) {
                    promise.resolve();
                } else {
                    promise.reject(new Error("error deleting voicemail box greeting"));
                }
            });
        });
    };

    const _onVoicemailGreetingConverted = (callback) => {
        _greetingSocket.subscribeToEvent("voicemailBoxGreetingConverted", (voicemailBoxGreeting) => {
            let voicemailBoxGreetingPresentationObject = _buildVoicemailBoxGreetingForDisplay(voicemailBoxGreeting);
            callback(voicemailBoxGreetingPresentationObject);
        });
    };

    const _dispose = () => {
        _greetingSocket.disposeOfEvents();
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        const self = this;

        self.dispose = _dispose;
        self.init = _init;
        self.getCurrentGreetingId = _getCurrentGreetingId;
        self.getVoicemailBoxGreetings = _getVoicemailBoxGreetings;
        self.onVoicemailBoxGreetingConverted = _onVoicemailGreetingConverted;
        self.saveVoicemailBoxGreetings = _saveVoicemailBoxGreetings;
    };
});

